export const TIN_MATCH_MODALS_LOADING_STATE = {
    GET_REQUESTED_COUNT_LOADING: "GET_REQUESTED_COUNT_LOADING",
    GET_REQUESTED_COUNT_READY: "GET_REQUESTED_COUNT_READY",
    GET_TIN_MATCH_FEE_LOADING: "GET_TIN_MATCH_FEE_LOADING",
    GET_TIN_MATCH_FEE_READY: "GET_TIN_MATCH_FEE_READY",
};